import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-tables.css';

var getClassNameList = classNames.bind(styles);
var UitkTableBody = function (props) {
    var children = props.children, className = props.className;
    return React.createElement("tbody", { className: getClassNameList(className) }, children);
};
UitkTableBody.displayName = 'UitkTableBody';

export { UitkTableBody };
